import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { SHOW_SECOND_CBILS_ACCOUNT_SCHEDULED_REPAYMENTS_MODAL } from '../../modals/repaymentScheduleModal/RepaymentScheduleModal.actions';
import { StatusLines } from '../../multiLoanDashboard/dashboardComponents/statusLines/StatusLines';
import {
    getCBILSScheduledPayments,
    getOutstandingTotal,
    getSecondCBILSAccount
} from '../CBILSSelector';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    showSchedule: () => {
        dispatch({
            type: SHOW_SECOND_CBILS_ACCOUNT_SCHEDULED_REPAYMENTS_MODAL
        });
    }
});

const mapStateToProps = (state: RootState) => {
    return {
        hasRepaymentSchedule: !!getEqualRepaymentsInfo(state),
        repaymentAmount: getNextRepaymentAmount(state),
        repaymentDate: getNextRepaymentDate(state),
        totalBalance: getOutstandingTotal(state)
    };
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(StatusLines);

function getNextRepaymentAmount(state: RootState) {
    return getRepaymentsSchedule(state)?.[0]?.total;
}

function getNextRepaymentDate(state: RootState) {
    return getRepaymentsSchedule(state)?.[0]?.date;
}

function getRepaymentsSchedule(state: RootState) {
    return getSecondCBILSAccount(state)?.scheduled_payments?.schedule;
}

function getEqualRepaymentsInfo(state: RootState) {
    return (
        getCBILSScheduledPayments(state)?.summary?.simplified_schedule
            ?.equal_repayments ?? undefined
    );
}
